<template>
  <BModal
    :title="titulo"
    :no-close-on-esc="true"
    :no-close-on-backdrop="true"
    :hide-header-close="true"
    :centered="true"
    ok-title="Sim"
    cancel-title="Não"
    v-model="mostrar"
    @ok="ok"
    @cancel="cancel">
    <div>
      <p>{{ mensagem }}</p>
    </div>
  </BModal>
</template>

<script>
import { BModal } from 'bootstrap-vue/es/components'

export default {
  name: 'ModalConfirmacao',
  components: {
    BModal,
  },
  props: {
    titulo: {
      type: String,
      required: true,
    },
    mensagem: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      resolve: null,
      mostrar: false,
    }
  },
  methods: {
    pop() {
      this.mostrar = true
      return new Promise(resolve => {
        this.resolve = resolve
      })
    },
    ok() {
      this.mostrar = false
      this.resolve(true)
    },
    cancel() {
      this.mostrar = false
      this.resolve(false)
    },
  },
}

</script>
